<script setup lang="ts">
defineProps<{
  small?: boolean
}>()

const navigation = [
  { name: 'Solutions', href: '/solutions' },
  { name: 'About Us', href: '/about-us' },
  { name: 'Work with us', href: '/work-with-us' },
  { name: 'Contact', href: '/get-in-touch' },
]

const legal = [
  { name: 'Privacy Policy', href: '/privacy-policy' },
  { name: 'Cookie Policy', href: '/cookie-policy' },
]
</script>

<template>
  <footer class="footer" :class="{ 'small': small }">
    <div class="container mx-auto">
      <div v-if="!small" class="footer-top grid grid-cols-1 lg:grid-cols-[1.5fr_2fr_0.5fr] gap-10 lg:gap-16 mb-10">
        <div class="footer-brand flex flex-col items-center lg:items-start text-center lg:text-left">
          <img src="../assets/logo/logo.svg" alt="Voxbet" class="footer-logo" />
          <p class="footer-tagline text-sm opacity-50 max-w-xs">
            Next-generation voice and message intelligence for the global betting industry.
          </p>
        </div>

        <div class="footer-nav flex justify-center lg:justify-start gap-16 lg:gap-20">
          <div class="footer-column">
            <h3 class="text-sm uppercase tracking-widest mb-6 font-semibold">Navigation</h3>
            <ul class="footer-links flex flex-col gap-3 list-none p-0">
              <li v-for="item in navigation" :key="item.name">
                <RouterLink :to="item.href" class="text-sm opacity-60 hover:text-voxbet-neon hover:opacity-100 transition-all">{{ item.name }}</RouterLink>
              </li>
            </ul>
          </div>
        </div>

        <div class="footer-social flex flex-col items-center lg:items-start">
          <h3 class="text-sm uppercase tracking-widest mb-6 font-semibold">Follow Us</h3>
          <div class="social-icons flex gap-4">
            <a href="https://www.linkedin.com/company/voxbet/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" class="social-icon opacity-60 hover:opacity-100 hover:text-voxbet-neon transition-all">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>
            </a>
          </div>
        </div>
      </div>

      <div class="footer-bottom flex flex-col md:flex-row justify-between items-center gap-6" :class="{ 'border-t border-white/10 pt-8': !small }">
        <div class="footer-legal">
          <ul class="legal-links flex gap-6 list-none p-0">
            <li v-for="item in legal" :key="item.name">
              <RouterLink :to="item.href" class="text-xs opacity-60 hover:opacity-100 transition-all">{{ item.name }}</RouterLink>
            </li>
          </ul>
        </div>
        
        <img src="../assets/logo/icon.svg" alt="Voxbet" class="h-6 w-auto" />
        
        <p class="copyright text-xs opacity-60">&copy; {{ new Date().getFullYear() }} Voxbet. All rights reserved.</p>
      </div>
    </div>
  </footer>

</template>


